import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../util/axiosConfig";
import "../../assets/css/container/board/WriteNotice.css";
import "../../assets/css/component/board/BoardActions.css";
import {useAuth} from "../../global/AuthContext";
import TiptapEditor from "../../component/TiptapEditor";

export default function WriteNotice() {
	// @ts-ignore
	const { user } = useAuth();
	const navigate = useNavigate();

	const [title, setTitle] = useState("");
	const [content, setContent] = useState("");

	if (user?.role !== "admin") {
		return <p>권한이 없습니다.</p>;
	}

	const handleSubmit = async () => {
		if (!title.trim() || !content.trim()) {
			alert("제목과 내용을 입력해주세요.");
			return;
		}

		await axios.post("/api/notices", { title, content });
		navigate("/notices");
	};

	return (
		<div className="WriteNotice">
			<h2>공지 작성</h2>
			<input
				type="text"
				placeholder="제목 입력"
				value={title}
				onChange={(e) => setTitle(e.target.value)}
			/>
			<TiptapEditor content={content} onChange={setContent} />

			<div className="BoardEditorActions">
				<button onClick={handleSubmit}>등록</button>
				<button onClick={() => navigate("/notices")}>취소</button>
			</div>
		</div>
	);
}
